export const reasons = {
  1: "Spam",
  2: "Nudity or sexually explicit material",
  3: "Child abuse",
  4: "Hate speech",
  5: "Suicide or self-injury",
  6: "Misinformation",
  7: "Promotes terrorism",
  8: "Harassment or bullying",
  9: "Other"
};
